export class PathSegment {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "segmentType",
            "baseName": "segmentType",
            "type": "SegmentType",
            "format": ""
        },
        {
            "name": "segmentStringValue",
            "baseName": "segmentStringValue",
            "type": "string",
            "format": ""
        },
        {
            "name": "segmentPartitionType",
            "baseName": "segmentPartitionType",
            "type": "PartitionSegmentType",
            "format": ""
        },
        {
            "name": "segmentPartitionFormat",
            "baseName": "segmentPartitionFormat",
            "type": "PartitionFormat",
            "format": ""
        },
        {
            "name": "segmentPartitionName",
            "baseName": "segmentPartitionName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PathSegment.attributeTypeMap;
    }
    constructor() {
    }
}
